import { Mail, ChevronUp, User } from 'lucide-react';
import { useState } from "react";
import { UtilApp } from "../../services/Utils/UtilApp";
import { UIMessage } from "./UIMessage";
import { My } from "../../services/My";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";
import { Util } from "../../services/Utils/Util";
import { getDisplayName, resolveMessageUser } from "../../services/Utils/userDisplayName";
import { IconChevronDown } from './FigmaIcons';

interface IMessageItem {
  m: UIMessage,
  roomUsers?: { id: string; name?: string; photoUrl?: string | null }[],
}

const MessageEmailItem: React.FC<IMessageItem> = ({ m, roomUsers }) => {
  const [hide, setHide] = useState(true);
  const user = resolveMessageUser(m.msg.user, roomUsers);

  return (
    <div className="flex flex-col gap-2 p-2">
      {m.msg.text && (
        <div
          className="flex flex-col bg-background border rounded-lg overflow-hidden cursor-pointer transition-shadow hover:shadow-sm"
          onClick={() => setHide(!hide)}
        >
          <div className="flex items-center gap-3 p-3 bg-muted/50 border-b">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-600">
              <Mail className="w-4 h-4" />
            </div>

            <div className={`text-sm text-[color:rgb(var(--text-body))] line-clamp-2 flex-1 ${hide ? "line-clamp-1" : ""}`}>
              {hide ? "Click to expand email content..." : "Email Content"}
            </div>

            <div className="text-muted-foreground">
              {hide ? <IconChevronDown className="w-5 h-5" /> : <ChevronUp className="w-5 h-5" />}
            </div>
          </div>

          <div className={`p-4 text-sm text-[color:rgb(var(--text-body))] bg-background whitespace-pre-wrap transition-all duration-300 ${hide ? "hidden" : "block"}`}>
            {m.msg.text}
          </div>
        </div>
      )}

      <div className="flex items-center gap-3 pl-1">
        {m.msg.senderEmail === m.msg.user.email ? (
          <>
            <Avatar className="w-8 h-8 rounded-full">
              <AvatarImage src={user.photoUrl || Util.ANONYMOUS_PHOTO_URL} alt={getDisplayName(user)} />
              <AvatarFallback>{getDisplayName(user)?.[0]}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-[color:rgb(var(--text-title))]">{getDisplayName(user)}</span>
              <span className="text-meta-sm text-muted-foreground">{UtilApp.dateStrToTime(m.msg.created)}</span>
            </div>
          </>
        ) : (
          <>
            <Avatar className="w-8 h-8 rounded-full bg-muted">
              <AvatarFallback><User className="w-4 h-4 text-muted-foreground" /></AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-[color:rgb(var(--text-title))]">{m.msg.senderEmail}</span>
              <span className="text-meta-sm text-muted-foreground">{UtilApp.dateStrToDay(m.msg.created, My.user.lang)}</span>
            </div>
          </>
        )}
      </div>
    </div >
  );
}

export default MessageEmailItem;